import React from 'react'
import { LinearProgress, makeStyles, withStyles } from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    backgroundColor: BASE_COLORS.White,
    borderRadius: 10,
    padding: '4px 12px',
    flexDirection: 'column'
  },
  title: {
    color: GRAY_COLORS[700],
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '18px',
    fontFamily: 'Inter'
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexDirection: 'row'
  },
  counters: {}
}))
const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 8,
    borderRadius: 4,
    width: '100%'
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 4,
    backgroundColor: PRIMARY_COLORS[600]
  }
}))(LinearProgress)
const StatusProgress = ({ contractStatusTrack }) => {
  const classes = useStyle()

  const progress =
    (contractStatusTrack?.current / contractStatusTrack?.total) * 100
  return (
    <div className={classes.rootDiv}>
      <div className={classes.title}>{contractStatusTrack?.name}</div>
      <div className={classes.progressRow}>
        <BorderLinearProgress variant="determinate" value={progress} />
        <div className={classes.title}>
          {' '}
          {`${contractStatusTrack?.current}/${contractStatusTrack?.total}`}
        </div>
      </div>
    </div>
  )
}
export default StatusProgress
